/* eslint-disable react/prop-types */
import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const ImageItem = ({ item, handleEdit, isUltimateDesign }) => {
  const { media, ...mediaQuery } = useMedia(getImage(item));
  const imageName = (mediaQuery.isFetching && 'Loading ...') || mediaQuery.error?.message || media.title;

  return (
    <InfoItem image={media.src} onClick={handleEdit}>
      {isUltimateDesign ? item.title : imageName}
    </InfoItem>
  );
};

export default ImageItem;
